<template>
  <div>
    <el-upload
      ref='upload'
      class='upload-demo'
      :action='uploadUrlNew'
      :auto-upload='true'
      :show-file-list='false'
      :data='uploadData'
      :on-success='planOnSuccess'
      :before-upload='beforeUpload'
    >
      <el-button v-if='isButton' type='primary' size='mini'>批量导入</el-button>
      <i v-else class='el-icon-upload el-icon--right'
         style=' color: rgba(51, 136, 255, 1);'>批量导入</i>
    </el-upload>
  </div>
</template>

<script>

  import { baseUrl } from '@/config/env';

  export default {
    name: 'batchImport',
    props: {
      //  导入地址
      uploadUrl: {
        type: String,
        default: '',
      },
      isButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        uploadData: {
          mFile: '',//文件名
        },
        uploadUrlNew: baseUrl + this.uploadUrl,
      };
    },
    methods: {
      /**
       *导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: () => {
            this.$emit('importSuccess',res.data);
          },
        });
      },
      beforeUpload(file) {
        // console.log(file)
        if (file.name.split('.')[1] === 'xls' || file.name.split('.')[1] === 'xlsx') {
          this.uploadData.mFile = file.name;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  .upload-demo {
    padding-right: 10px;
  }
</style>
